export interface ParentLink {
  id: string;
  parentId: string | null | undefined;
}

export function collectDescendantIds(
  rootId: string,
  links: readonly ParentLink[],
): Set<string> {
  const descendants = new Set<string>([rootId]);
  let grew = true;
  while (grew) {
    grew = false;
    for (const { id, parentId } of links) {
      if (parentId && descendants.has(parentId) && !descendants.has(id)) {
        descendants.add(id);
        grew = true;
      }
    }
  }
  return descendants;
}
